<template>
  <div class="stub">
    <h1>{{ $t('page.LOADING_ERROR') }}</h1>
  </div>
</template>

<script>
export default {
  name: 'LoadingError'
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base.scss";

</style>
